import { jsx } from "../../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { CheckCircleSolid as e } from "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/check-circle-solid.es.es.js";
import "../../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { Secondary, Common, Text } from "../../../foundations/palette.es.js";
import { BorderRadius } from "../../../foundations/border-radius.es.js";
const IconContainer = styled("div")({
  marginRight: Spacing["750"],
  "&.mobile-version": {
    paddingTop: Spacing["250"],
    alignItems: Alignment.flexStart,
    alignSelf: Alignment.stretch
  }
});
const IconWrapper = styled("div", styledOptions)(({
  isActive
}) => ({
  padding: Spacing["250"],
  background: isActive ? Secondary.main : Common.white.main,
  borderRadius: BorderRadius.brand,
  color: isActive ? Common.white.main : Text.secondary,
  "& svg": {
    width: 20,
    height: 20
  }
}));
function ProfileQuestionnaireIcon({
  isMobile,
  isSectionCompleted,
  isSectionActive,
  activeIcon,
  inactiveIcon
}) {
  return /* @__PURE__ */ jsx(IconContainer, { className: isMobile ? "mobile-version" : void 0, children: isSectionCompleted ? /* @__PURE__ */ jsx(e, { color: "secondary", style: {
    fontSize: 28
  } }) : /* @__PURE__ */ jsx(IconWrapper, { isActive: isSectionActive, children: isSectionActive ? activeIcon : inactiveIcon }) });
}
export {
  ProfileQuestionnaireIcon
};
//# sourceMappingURL=profile-questionnaire-icon.es.js.map
